import { render } from "./icon.vue?vue&type=template&id=2761cf68&scoped=true"
import script from "./icon.vue?vue&type=script&lang=ts"
export * from "./icon.vue?vue&type=script&lang=ts"

import "./icon.vue?vue&type=style&index=0&id=2761cf68&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2761cf68"

export default script